module.exports = __webpack_public_path__ + "img/invoiceSuc.2a29d2f0.png";